


// ***********************************  Please don't change file name for dark mode (use in _app.js) ******************************************

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import {
    fetchCategoryVideos
} from "store/posts/actions";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Router, Link } from "routes";
import {
  isMobile,
  isBrowser
} from "react-device-detect";
import Icon from '@material-ui/core/Icon';
import TagManager from 'react-gtm-module';
import Hidden from '@material-ui/core/Hidden';
import ContentTitle from "/components/contentTitle";
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import MobileVideoCards from "/components/Video/MobileVideoCards";
import Button from '@material-ui/core/Button';
import Axios from "/plugins/axios";
import ThereIsNoItem from '/components/thereIsNoItem';
import SeoMeta from '/components/seoMeta';
import ReadAll from '/components/CardsSection/readAll';
import {getFooterTopOffset, infiniteHandleScroll} from '/components/NextMore/infiniteHandleScroll';
import {c} from '/utils/log';
import { duwunCoverLogo } from '/utils/common';

const tagManagerArgs = {
    dataLayer: {
        Section: 'Section',
    }
}

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
  }
});
class CategoryVideos extends Component {
  constructor(props){
    super(props);
    this.state = {
        newsItems: [],
        loading: false,
        next: this.props.links.next,
        url: this.props.url,
    }
    this.handleScroll = infiniteHandleScroll.bind(this, this);
    // this.handleScroll = this.handleScroll.bind(this);
  }

    static async getInitialProps({ store, asPath, query, res, isServer }) {
        const { id } = query;
        const currentDateTime = new Date().toISOString();
        const type = asPath.includes("/tv/") || asPath.includes("/tv") ? 'TV' : 'VIDEO';
        await store.execSagaTasks(isServer, dispatch => {
          dispatch(fetchCategoryVideos(id, currentDateTime, type));
        });

        if(!store.getState().posts.categoryVideos) {
          res.statusCode = store.getState().posts.error.status || 404;
          // return { id };
        }
        return {id, currentDateTime, type}
    }

    static getDerivedStateFromProps(nextProps, prevState){
        if(prevState.url.query !== nextProps.url.query){
            return ({
                next: nextProps.links.next,
                newsItems:[], // next item remove from prev route when route change
                // next: `/categories/${ nextProps.url.query.category }?page=2`,// when next is null, next_btn disappear. But when route change, next is [1,2,3,4,5], next_btn still disappear.So this way has been resolved for this error.
            })
        }
        return {};

    }
    nextPage = (url) => {
        // const nextPerPage = isMobile ? 6 : 8
        url = `/videos/categories/${this.props.url.query.id}?type=${this.props.type}&published_date=${this.props.currentDateTime}&perPage=${8}&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
        this.setState({
            loading: true
        });
        Axios.get(url)
            .then(res => {
                res.data.data.map((value) => this.state.newsItems.push(value))
                this.setState({
                    newsItems: this.state.newsItems,
                    next: res.data.links.next,
                    url: this.props.url,
                    loading: false,

                })
            })
    }

    __nextBtn () {
        const {classes, uniReadable} = this.props;
        if(this.state.next != null) {
            return (
              <div className="next_more_btn_gtm" style={{textAlign: 'center', padding: '20px 0px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  style={{boxShadow: 'none', fontWeight: 'bold', borderRadius: 50}}
                  onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
                >
                  <span>
                    {
                        uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                    }
                  </span>
                  {this.state.loading ?
                    <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                        :
                    <div style={{display: 'inline-flex'}}>
                      <Icon>keyboard_arrow_down</Icon>
                    </div>
                     }
                </Button>
              </div>
            )
        }
    }

render() {
    const { links, classes, videos, categoriesStore, videoCategory, metaTag } = this.props;
    const { newsItems } =this.state;
    let videoFilterObj = categoriesStore && categoriesStore.filter(item => item.slug === 'videos' ? item.slug === 'videos': null)
    let subCategoryVideoFilterObj = videoFilterObj && videoFilterObj.length !== 0 && videoFilterObj[0].sub_categories.filter(item => item.slug === this.props.url.query.id )

    let tvFilterObj = categoriesStore && categoriesStore.filter(item => item.slug === 'tv')
    let subCategoryTvFilterObj = tvFilterObj && tvFilterObj.length !== 0 && tvFilterObj[0].sub_categories.filter(item => item.slug === this.props.url.query.id )

    // let videoOgImage = subCategoryVideoFilterObj && subCategoryVideoFilterObj[0] ? subCategoryVideoFilterObj[0].cover.social ? subCategoryVideoFilterObj[0].cover.social : {duwunCoverLogo} : null
    let tvOgImage = subCategoryTvFilterObj && subCategoryTvFilterObj[0] ? subCategoryTvFilterObj[0].cover.social ? subCategoryTvFilterObj[0].cover.social : duwunCoverLogo: null
    let viewAllRouteName = this.props.type === 'VIDEO' ? 'videos' : 'tv';
    let viewAllStr = this.props.type === 'VIDEO' ? 'Videos' : 'TVs';
    let categoryName = videoCategory ? videoCategory.name : '';
    let categoryColor = videoCategory ? videoCategory.color : '';
    let categoryType = videoCategory ? videoCategory.type : '';

    let videoOgImage = videoFilterObj && videoFilterObj.length !== 0 && videoFilterObj[0].cover.social ? videoFilterObj[0].cover.social : {duwunCoverLogo}

    return (
      <div>
        <Head>
          <title>Category - {this.props.url.query.id}</title>
        </Head>
        <SeoMeta
            url={`${process.env.BACKEND_URL}${this.props.url.asPath}`}
            type="video.other"
            title={`${this.props.url.query.id}`}
            description={metaTag && metaTag.description}
            image={videoOgImage}
            themeColor={categoryColor}
            section={metaTag && metaTag.section ? metaTag.section : categoryName}
            keywords={metaTag && metaTag.keywords ? metaTag.keywords : categoryName}
          />        
        <NProgress />

        <Hidden only={['md', 'lg', 'xl']}>
            <div style={{padding: '20px 10px 10px'}}>
                <ContentTitle contentTitle={`${this.props.url.query.id}`} color="#fff" typoComponent="h1" />
            </div>
            {
                videos.length === 0 ?
                <ThereIsNoItem thereIsNoItem="There is no video." /> :
                <MobileVideoCards items={videos} newsItems={newsItems.length > 0 ? newsItems: null} />

            }
             { links.next ?  this.__nextBtn() : null}
        </Hidden>
        <Hidden smDown>
            <div className={classes.root}>
                <div className='layout'>
                    <ContentTitle contentTitle={`${this.props.url.query.id}`} color="#fff" typoComponent="h1" />
                    {
                        videos.length === 0 ?
                        <ThereIsNoItem thereIsNoItem="There is no video." /> :
                        <DesktopVideoCards items={videos} newsItems={newsItems.length > 0 ? newsItems: null} />
                    }
                     { links.next ?  this.__nextBtn() : null}
                </div>
            </div>
        </Hidden>
        {
          this.state.next == null &&
          <ReadAll
            items={videos}
            routeName={viewAllRouteName}
            paramsName={{}}
            readAll={`View All Latest ${viewAllStr}`}
            color='#fff' />
        }
      </div>
    );
    }

    componentDidMount () {

        this.setState({
            ssrDone: true,
        });

        setTimeout(() => {
            this.previousFooterTopOffset = getFooterTopOffset();
            c.log("categoryVideos.js:componentDidMount:previousFooterTopOffset:Timeout:500");
            c.log(this.previousFooterTopOffset, "vs", this.newFooterTopOffset);
            window.addEventListener('scroll', this.handleScroll);
        },500);        
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        if (typeof localStorage !== "undefined") {
            localStorage.setItem('category', null);
        }        
    }

    // handleScroll(event) {
    //     // console.log("handleScroll > event:");
    //     // console.log(event);
    //     // console.log("handleScroll > that:");
    //     // console.log(that);
    //     if(window.pageYOffset > 200 && !this.pageFiveLoaded) {
    //       if(this.state.next != null && !this.state.loading) {
    //         this.nextPage(this.state.next);
    //       }
    //       let nextApi = this.state.next;
    //       let endInfiniteScroll = nextApi != null && nextApi.includes("page=5");
    //       if(endInfiniteScroll){
    //         this.pageFiveLoaded = true;
    //       }
    //     }
    // }

    componentDidUpdate(previousProps, previousState){
        c.log("categoryVideos.js::componentDidUpdate()");
        tagManagerArgs.dataLayer.Section = 'videos';
        TagManager.dataLayer(tagManagerArgs);

        if (typeof localStorage !== "undefined") {
            localStorage.setItem('category', 'videos');
        }        

        let nextPage = this.state.next != null && this.state.next.split('?').length > 0 ? this.state.next.split('?')[1] : '';
        this.nextPageNumber = nextPage.split('page=').length > 0 ? parseInt(nextPage.split('page=')[1]) : 2;

        if(previousProps.url.query!= this.props.url.query) {
            this.initialPageLoaded = false;
            this.nextPageNumber = 2;
        }

        {/* ***** showMore and infiniteScroll Events ***** */}
        if(this.state.ssrDone && !this.state.loading) {
            const currentPageNumber = this.nextPageNumber ? this.nextPageNumber-2 : 0;
            const pageUrl = document.location.origin + document.location.pathname;
            const showMorePagePath = currentPageNumber <= 1 ? pageUrl : pageUrl + "#page-" + currentPageNumber;            
            if(currentPageNumber > 1) {  
                window.parent.location.hash = "page-" + currentPageNumber;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'showMoreEvent',
                    showMoreEventPage: showMorePagePath,
                    showMoreEventTitle: this.props.url && this.props.url.query.id? "Category Videos - " + this.props.url.query.id : 'No Title'
                });                
            }            
        }

        setTimeout(() => {
            this.newFooterTopOffset = getFooterTopOffset();
            c.log("categoryVideos.js:componentDidUpdate:newFooterTopOffset:Timeout:500");
            c.log(this.previousFooterTopOffset, "vs", this.newFooterTopOffset);
        },500);
    }
}

CategoryVideos.propTypes = {
  classes: PropTypes.object.isRequired,
  videos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
  links: state.posts.categoryVideos.links,
  videos: state.posts.categoryVideos.data,
  videoCategory: state.posts.categoryVideos.category,
  metaTag: state.posts.categoryVideos && state.posts.categoryVideos.metaTag || null
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCategoryVideos
    },
    dispatch
  );

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(CategoryVideos))
);
